export const robbonKPIValues = [
    {
        "company_name":"GARUDA TIMUR PACIFIC",
        "group_company":"GARUDAFOOD",
        "total_credit_limit":0.0,
        "total_credit_outstanding":0.0,
        "total_liabilities":41359405.6000000015,
        "total_credit_limit_utilization":0.0,
        "percent_closed_loop":1.2,
        "new_product_and_services_engagements":1.0,
        "wallet_size":100.0,
        "wallet_share":40.0
    },
    {
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD",
        "total_credit_limit":2606100000000.0,
        "total_credit_outstanding":1278412500000.0,
        "total_liabilities":352904233772.424987793,
        "total_credit_limit_utilization":49.0546218487,
        "percent_closed_loop":3.1,
        "new_product_and_services_engagements":6.0,
        "wallet_size":739750.0,
        "wallet_share":40.0
    },
    {
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "total_credit_limit":99674131006.050201416,
        "total_credit_outstanding":3545011.2102000001,
        "total_liabilities":18141290827028.61328125,
        "total_credit_limit_utilization":0.0035566011,
        "percent_closed_loop":2.1,
        "new_product_and_services_engagements":7.0,
        "wallet_size":6080320.0,
        "wallet_share":30.0
    },
    {
        "company_name":"PERUSAHAAN LISTRIK NEGARA, PT (PERSERO)",
        "group_company":"PLN GROUP",
        "total_credit_limit":0.0,
        "total_credit_outstanding":0.0,
        "total_liabilities":2019939.2,
        "total_credit_limit_utilization":0.0,
        "percent_closed_loop":2.4,
        "new_product_and_services_engagements":3.0,
        "wallet_size":200.0,
        "wallet_share":1.0
    },
    {
        "company_name":"PT SINARNIAGA SEJAHTERA",
        "group_company":"GARUDAFOOD",
        "total_credit_limit":0.0,
        "total_credit_outstanding":0.0,
        "total_liabilities":1007410387.9000000954,
        "total_credit_limit_utilization":0.0,
        "percent_closed_loop":1.9,
        "new_product_and_services_engagements":1.0,
        "wallet_size":100.0,
        "wallet_share":1.0
    },
    {
        "company_name":"PUPUK INDONESIA PERSERO",
        "group_company":"PUPUK INDONESIA",
        "total_credit_limit":0.0,
        "total_credit_outstanding":0.0,
        "total_liabilities":2126329214747.9001464844,
        "total_credit_limit_utilization":0.0,
        "percent_closed_loop":2.8,
        "new_product_and_services_engagements":1.0,
        "wallet_size":472517.7778,
        "wallet_share":45.0
    },
    {
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP",
        "total_credit_limit":3885499386546.1591796875,
        "total_credit_outstanding":3163917230214.01953125,
        "total_liabilities":1481404913115.0649414062,
        "total_credit_limit_utilization":81.4288439002,
        "percent_closed_loop":3.7,
        "new_product_and_services_engagements":2.0,
        "wallet_size":1788966.6669999999,
        "wallet_share":30.0
    },
    {
        "company_name":"TUDUNG PUTRA PUTRI JAYA",
        "group_company":"GARUDAFOOD",
        "total_credit_limit":0.0,
        "total_credit_outstanding":0.0,
        "total_liabilities":662848862.2000000477,
        "total_credit_limit_utilization":0.0,
        "percent_closed_loop":1.7,
        "new_product_and_services_engagements":1.0,
        "wallet_size":165.0,
        "wallet_share":40.0
    },
    {
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "total_credit_limit":772398502035.4725341797,
        "total_credit_outstanding":5830765142488.193359375,
        "total_liabilities":549497035226.1820068359,
        "total_credit_limit_utilization":754.8907885143,
        "percent_closed_loop":1.3,
        "new_product_and_services_engagements":0.0,
        "wallet_size":0.0,
        "wallet_share":0.0
    }
]